import { createAction, props } from '@ngrx/store';
import { DialogData } from '../../components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';
import {CacheItem} from "../../cache.model";

export const addCacheStart = createAction('ZEIT::ADD_CACHE_START', props<{ item: DialogData }>());
export const addCacheSucceeded = createAction('ZEIT::ADD_CACHE_SUCCEEDED', props<{ item: CacheItem[] }>());
export const addCacheFailed = createAction('ZEIT::ADD_CACHE_FAILED', props<{ error: Error }>());
